<template>
  <div>
    <v-row class="mt-1">
      <v-col cols=6 class="pr-1">
      <v-chip color="accentElement" class="black--text">
        <v-icon left> mdi-account-multiple</v-icon>
        {{ ageRating ? ageRating._id : " - " }}
      </v-chip>
      </v-col>
      <v-col cols=6 class="pl-1">
      <v-chip color="accentElement" class="black--text">
        <v-icon left> mdi-clock-outline</v-icon>
        {{ duration ? duration : ' - '}}
      </v-chip>
      </v-col>
    </v-row>
      <v-row>
        <v-col>
          <v-chip color="accentElement" :class="genre? 'black--text' : 'secondaryAction--text'">
            <v-icon color="black" left> mdi-book-open-blank-variant</v-icon>
            {{ genre ? genre._id : $t('storyHub.publishing.noGenre')}}
          </v-chip>
        </v-col>
      </v-row>
    <v-row>
      <v-col>
        <v-chip v-if="totalReviewCount > 0" color="accentElement" class="black--text">
          <v-rating
            hover
            dense
            length="5"
            color="#FFDE33"
            background-color="white"
            empty-icon="mdi-star"
            readonly
            :value="getAverageRating(reviews)"
          ></v-rating>
          <v-icon class="ml-3"> mdi-account</v-icon>
          {{ totalReviewCount }}
        </v-chip>
        <v-chip v-else color="accentElement" class="secondaryAction--text">{{ $t('storyHub.publishing.noReviews') }}</v-chip>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  props: {
    totalReviewCount: Number,
    duration: String,
    genre: Object,
    ageRating: Object,
    reviews: Object,
  },
  methods: {
    getAverageRating(reviews) {
      let ratingCount = 0;
      let ratingTotal = 0;
      for (const review of reviews.edges) {
        ratingTotal = review.node.rating + ratingTotal;
        ratingCount++;
      }
      let average = ratingTotal / ratingCount;

      return average;
    },
  },
};
</script>
<style lang="scss" scoped>
.v-chip {
  width: 100%;
}
::v-deep .v-chip .v-chip__content {
  margin: 0px auto;
}
</style>